/** Normaliza respuestas `{ success, data }` o arrays directos del API. */
export function unwrapList(res) {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    return [];
}
